import { Link, makeStyles, Typography } from "@material-ui/core";
import { Formik } from "formik";
import React from "react";
import { useIntl } from "react-intl";
import { Link as RouterLink } from "react-router-dom";
import * as yup from "yup";
import { SubmitButton, TextField } from "../../components/formik";
import { requestResetPassword } from "../../ducks/actions";
import useActionRequest from "../../hooks/useActionRequest";

const useStyles = makeStyles(theme => ({
  alignLeft: {
    alignSelf: "flex-start"
  },
  submitButton: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3)
  }
}));

const ForgotPasswordForm = () => {
  const intl = useIntl();
  const classes = useStyles();

  const validationSchema = yup.object().shape({
    email: yup.string().email().required()
  });
  const requestResetPasswordRequest = useActionRequest({
    action: requestResetPassword,
    successMessage: intl.formatMessage({
      id: "Auth.ForgotPasswordForm.RequestResetPasswordSuccess",
      defaultMessage: "Reset password email sent"
    }),
    errorMessage: intl.formatMessage({
      id: "Auth.ForgotPasswordForm.RequestResetPasswordError",
      defaultMessage: "Reset password email not sent"
    })
  });

  const onSubmit = value => requestResetPasswordRequest(value);

  return (
    <Formik validationSchema={validationSchema} onSubmit={onSubmit} initialValues={{ email: "" }}>
      <>
        <Typography variant="h4" className={classes.alignLeft} gutterBottom>
          {intl.formatMessage({
            id: "Auth.ForgotPasswordForm.ForgotPassword",
            defaultMessage: "Create or Reset Password"
          })}
        </Typography>
        <Typography variant="body1" className={classes.alignLeft}>
          {intl.formatMessage({
            id: "Auth.ForgotPasswordForm.Helper",
            defaultMessage:
              "Enter the email used for your account and we will send you a link to reset your password."
          })}
        </Typography>

        <TextField
          name="email"
          variant="outlined"
          label={intl.formatMessage({
            id: "Auth.ForgotPasswordForm.EmailAddress",
            defaultMessage: "E-mail address"
          })}
          fullWidth
        />
        <SubmitButton
          variant="contained"
          color="primary"
          className={classes.submitButton}
          fullWidth
        >
          {intl.formatMessage({
            id: "Auth.ForgotPasswordForm.ResetPassword",
            defaultMessage: "Reset Password"
          })}
        </SubmitButton>

        <Typography>
          {intl.formatMessage({
            id: "Auth.ForgotPasswordForm.NeedHelp",
            defaultMessage: "Need help?"
          })}
          &nbsp;
          <Link to="/contact-us" component={RouterLink}>
            {intl.formatMessage({
              id: "Auth.ForgotPasswordForm.ContactUs",
              defaultMessage: "Contact us."
            })}
          </Link>
        </Typography>
      </>
    </Formik>
  );
};

export default ForgotPasswordForm;
